import { DateTime } from 'luxon'

//constants
import { PAYOUT_MAINTENANCE } from 'constants/index'

const startInMillis = DateTime.fromISO(PAYOUT_MAINTENANCE.START).toMillis()
const endInMillis = DateTime.fromISO(PAYOUT_MAINTENANCE.END).toMillis()

export const isPayoutMaintenanceGiftCard = (giftCardName?: string) =>
  !!giftCardName && PAYOUT_MAINTENANCE.GIFT_CARD_NAME_PATTERN.test(giftCardName)

export const isPayoutMaintenanceActive = (nowInMillis: number) =>
  nowInMillis >= startInMillis && nowInMillis < endInMillis

export const shouldShowPayoutMaintenanceNotice = (
  giftCardName: string | undefined,
  nowInMillis: number
) => isPayoutMaintenanceGiftCard(giftCardName) && isPayoutMaintenanceActive(nowInMillis)

// Time until the window starts or ends, or null once it is over
export const getMsUntilPayoutMaintenanceChange = (nowInMillis: number) => {
  if (nowInMillis < startInMillis) {
    return startInMillis - nowInMillis
  }
  if (nowInMillis < endInMillis) {
    return endInMillis - nowInMillis
  }
  return null
}
